import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import { Axios } from '../axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';

export type UpdateMandatePayload = {
  is_primary?: boolean;
  revoke?: boolean;
};

export const useUpdateCustomerMandate = () => {
  const updateMandate = async (
    customerId: number,
    mandateId: number,
    payload: UpdateMandatePayload
  ) => {
    const url = `/api/admin/customer/${customerId}/mandates/${mandateId}`;
    const response = await Axios.post(url, payload);
    return response.data;
  };

  return useMutation<
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    any,
    AxiosError<BaseError>,
    { customerId: number; mandateId: number; payload: UpdateMandatePayload }
  >(
    ({ customerId, mandateId, payload }) =>
      updateMandate(customerId, mandateId, payload),
    {
      useErrorBoundary: false
    }
  );
};
